module.exports = __webpack_public_path__ + "static/js/session.02dfc86a.chunk.worker.js"